import { Helmet } from "react-helmet";
import {
    Box,
    ClickAwayListener,
    Stack,
    MenuItem,
    MenuList,
    Divider,
    InputAdornment,
    TextField,
    Tab,
    Tabs,
    Select,
    Collapse,
    Grid,
    Typography,
    Button,
    usePagination,
    Popper,
    FormGroup,
    FormControlLabel,
    Checkbox,
    Paper
} from "@mui/material";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { makeStyles } from "@mui/styles";
import { useTranslation } from "react-i18next";
import AccessibleIcon from "@mui/icons-material/Accessible";
import { Link as RouterLink, useNavigate, useParams } from "react-router-dom";
import Search from "@mui/icons-material/Search";
import React, { useEffect, useMemo } from "react";
import { DropResult, DragDropContext, Droppable, OnDragEndResponder, Draggable } from 'react-beautiful-dnd';
import DraggableList from '../DraggableList';
import competencyService from "../../../../services/competency.service";
import cssVariables from "../../../../theme/cssVariables";
import { styled } from "@mui/styles";
import { ReactComponent as PlusIcon } from "../../../../icons/plus.svg";
import { ReactComponent as ChevronExpandDown } from "../../../../assets/icons/chevron-expand-down.svg";
import { ReactComponent as ChevronExpandUp } from "../../../../assets/icons/chevron-expand-up.svg";
import DialogSubTitle from "../../../../components/DialogSubTitle";
import { ReactComponent as EditIcon } from "../../../../assets/icons/edit.svg";
import { ReactComponent as DeleteIcon } from "../../../../assets/icons/delete.svg";
import { ReactComponent as Calendar } from "../../../../assets/icons/calendar.svg";
import { ReactComponent as ChevronDown } from "../../../../assets/icons/chevronDown.svg";
import { ReactComponent as ChevronRight } from "../../../../assets/icons/chevronRight.svg";
import { ReactComponent as IconImport } from "../../../../assets/icons/import.svg";
import { ReactComponent as Doner } from "../../../../assets/icons/doner.svg";
import { ReactComponent as XIcon } from "../../../../assets/icons/xIcon.svg";
import { ReactComponent as Route } from "../../../../assets/images/route.svg";
import { ReactComponent as Reopen } from "../../../../assets/images/reopen.svg";
import { ReactComponent as CancelIcon } from "../../../../assets/icons/cancelMF.svg";
import { ReactComponent as RestoreIcon } from "../../../../assets/icons/restore.svg";
import exports from "../../../../assets/images/export.png";
// import DotMenuGoalGroup from "./DotMenuGoalGroup";
import { ReactComponent as Nodata } from "../../../../assets/icons/nodata.svg";
import SimpleDialog from "../../../../components/SimpleDialog";
import ConfirmDialog from "../../../../components/ConfirmDialog";
import * as Util from "../../../../services/global.service";
import manageForm from "../../../../services/manageForm.service";
import { useSelector, useDispatch } from "react-redux";
import { listGoalGroup } from "../../../../actions/admin";
import MessageDialog from "../../../../components/inbox/MessageDialog";
import Column from "./Column";
import DialogReopen from "../../../../components/kpi/DialogReopen";
import DialogRoute from "../../../../components/kpi/DialogRoute";

function CustomPagination(props) {
    const { t } = useTranslation();
    const useStyles = makeStyles({
        paginationRoot: {
            color: `${cssVariables.color.primary}`,
            backgroundColor: "white!important",
            minWidth: "30px!important",
            padding: "5px!important",
        },
        paginationSelected: {
            color: "white!important",
            border: "1px solid rgba(93, 161, 150, 0.5)!important",
            backgroundColor: `${cssVariables.color.primary}!important`,
            minWidth: "30px!important",
            padding: "5px!important",
        },

    });
    const classes = useStyles();
    const List = styled("ul")({
        listStyle: "none",
        padding: 0,
        margin: 0,
        display: "flex",
    });
    const { items } = usePagination({
        count: props.count,
        showFirstButton: true,
        showLastButton: true,
    });
    return (
        <nav>
            <List>
                {items.length > 0 ? (
                    items.map(({ page, type, selected, ...item }, index) => {
                        let children = null;
                        selected = type === "page" && page === props.selected ? props.selected : selected
                        if (type === "start-ellipsis" || type === "end-ellipsis") {
                            children = "…";
                        } else if (type === "page") {
                            children = (
                                <Button
                                    {...item}
                                    size="small"
                                    type="button"
                                    style={{
                                        fontWeight: selected ? "bold" : undefined,
                                    }}
                                    variant="outlined"
                                    classes={{
                                        root: selected
                                            ? classes.paginationSelected
                                            : classes.paginationRoot,
                                    }}
                                    sx={{ margin: "0 5px" }}
                                >
                                    {page}
                                </Button>
                            );
                        } else if (type === "first" || type === "last") {
                            children = (
                                <Button
                                    {...item}
                                    disabled={type === "first" ? props.selected === 1 ? true : false : props.selected === props.count ? true : false}
                                    size="small"
                                    type="button"
                                    style={{
                                        fontWeight: selected ? "bold" : undefined,
                                    }}
                                    variant="outlined"
                                    classes={{
                                        root: selected
                                            ? classes.paginationSelected
                                            : classes.paginationRoot,
                                    }}
                                    sx={{ margin: "0 5px" }}
                                >
                                    {type === "first" ? <>&lt;&lt;</> : <>&gt;&gt;</>}
                                </Button>
                            );
                        } else {
                            children = (
                                <Button
                                    {...item}
                                    disabled={type === "previous" ? props.selected === 1 ? true : false : props.selected === props.count ? true : false}
                                    size="small"
                                    type="button"
                                    variant="outlined"
                                    classes={{
                                        root: classes.paginationRoot,
                                    }}
                                >
                                    {type === "previous"
                                        ? `${t('label.previous')}`
                                        : type === "next"
                                            ? `${t('label.next')}`
                                            : ""}
                                </Button>
                            );
                        }
                        return <li key={index}>{children}</li>;
                    })

                ) : (
                    <></>
                )}
                {props.setCurrentPage(items)}
            </List>
        </nav>
    );
}

const styles = {
    link: {
        color: "#5DA196",
        cursor: "pointer",
    },
    end: {
        color: "#A3A3A3",
    },
};

const ManageForm = (props) => {
    const useStyles = makeStyles({
        select: {
            '& div ': {
                padding: "8.5px 8.5px 8.5px 15px"
            },
        },
        dateTimePicker: {
            display: "flex !important",
            flexDirection: "column !important",
            justifyContent: "space-between !important",
            position: "relative",
            marginBottom: "14px !important",

        },
        plusSvg: {
            "& > path": {
                fill: "#fff",
                stroke: "#fff",
            },
        },
        input: {
            '& div > input': {
                height: '7px',
                position: "relative"
            }
        },
        draggingListItem: {
            background: 'rgb(235,235,235)'
        },
        toggleBtnRoot: {
            background: `transparent !important`,
            color: "#6B6B6B !important",
            width: "320px",
            border: "none !important",
        },
        fillWhite: {
            '& > path': {
                fill: '#FFFFFF'
            },
            '& g > path': {
                fill: '#FFFFFF'
            },
        },
        toggleBtnSelected: {
            background: `${cssVariables.color.primary}!important`,
            color: "#fff!important",
        },
        flexPaper: {
            flex: 1,
            minWidth: 350,
            "box-shadow": "0px 2px 10px rgba(0, 0, 0, 0.1) !important",
            "border-radius": "10px !important        "
        },
        tab: {
            "text-transform": "none !important",
            fontSize: "16px !important",
            fontWeight: "400 !important",
            color: "#A3A3A3 !important",
            '&.Mui-selected': {
                color: cssVariables.color.primary + " !important"
            }
        },
        root: {
            display: 'flex',
            width: "100%",
            flexWrap: 'wrap'
        }
    })
    let { open, dataTable, type, scroll, emitCollapse, openAdvance, changeOpenAdvance, dataFilterCycleType, setSum } = props
    const [items, setItems] = React.useState([]);
    const [mainItems, setMainItems] = React.useState([]);
    let { serial } = useParams()
    const classes = useStyles();
    const dispatch = useDispatch();
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const [search, setSearchValue] = React.useState("");
    const [employee, setEmployee] = React.useState("");
    const [position, setPosition] = React.useState("");
    const [team, setTeam] = React.useState("");
    const [cycle, setCycle] = React.useState("");
    const [formType, setFormType] = React.useState("");
    const [cycleType, setCycleType] = React.useState("");
    const [cycleName, setCycleName] = React.useState("");
    const [isProbation, setIsProbation] = React.useState(false)
    const [valueCycleName, setValueCycleName] = React.useState("");
    const [valueWorkflowStatus, setValueWorkflowStatus] = React.useState("");
    const [valueTemplateName, setValueTemplateName] = React.useState("");
    const [workflowStatus, setWorkflowStatus] = React.useState("");
    const [workflowStatusName, setWorkflowStatusName] = React.useState("");
    const [workflowStatusValue, setWorkflowStatusValue] = React.useState("");
    const [templateName, setTemplateName] = React.useState("");
    const [startDate, setStartDate] = React.useState(null);
    const [endDate, setEndDate] = React.useState(null);
    const [perPage, setPerPage] = React.useState(10);
    const [currentPage, setCurrentPage] = React.useState(1);
    const [totalPage, setTotalPage] = React.useState(1);
    const [checkResired, setCheckRsquired] = React.useState({});
    const [reSet, setreSet] = React.useState(false);
    const [openAdvanceFilters, setOpenAdvanceFilters] = React.useState(true);
    const [submit, setSunmit] = React.useState(false);
    const [isCollapse, setIsCollapse] = React.useState(false);
    const [isDeleteForm, setIsDeleteForm] = React.useState(false);
    const [isSuccessDeleteDialogOpen, openSuccessDeleteDialog] = React.useState(false);
    const [isSuccessRestoreDialogOpen, openSuccessRestoreDialog] = React.useState(false);
    const [isConfirmDeleteDialogOpen, openConfirmDeleteDialog] = React.useState(false);
    const [isConfirmRestoreDialogOpen, openConfirmRestoreDialog] = React.useState(false);
    const [workflowStatusValueOld, setWorkflowStatusValueOld] = React.useState("");
    const [dataWorkflowStatus, setDataWorkflowStatus] = React.useState([]);
    const [dataFilterTemplates, setDataFilterTemplates] = React.useState([]);
    const [sumFilter, setSumFilters] = React.useState(0);
    const [openFailedMessageDialog, setFailedMessageDialog] = React.useState(false);
    const [oldData, setOldData] = React.useState({});
    const [dataFilter, setDataFilter] = React.useState({});
    const [listFormStatus, setListFormStatus] = React.useState([])


    let getList = () => {
        manageForm.getFilter(cycleType).then((rs) => {
            setDataFilter(rs?.data)
            if (Util.formatData(rs?.data?.form_type, []).length > 0) {
                let filterData = rs?.data?.form_type.filter((rs) => rs?.type?.code === formType)
                if (Util.formatData(filterData, []).length > 0) {
                    setWorkflowStatusValue(filterData[0]?.routes)
                    setListFormStatus(filterData[0]?.routes)
                }
            }
        }).catch((err) => {

        })
    }
    useEffect(() => {
        getList()
    }, [cycleType]);
    const checkFilterData = () => {
        let total = 0
        if (Util.formatData(employee, false) !== false) {
            total += 1
        }
        if (Util.formatData(position, false) !== false) {
            total += 1
        }
        if (Util.formatData(team, false) !== false) {
            total += 1
        }
        if (Util.formatData(cycleType, false) !== false) {
            total += 1
        }
        if (cycleName !== "" && cycleName !== undefined) {
            total += 1
        }
        if (Util.formatData(formType, false) !== false) {
            total += 1
        }
        if (templateName !== "" && templateName !== undefined) {
            total += 1
        }
        if (workflowStatus !== "" && workflowStatus !== undefined) {
            total += 1
        }
        if (Util.formatData(endDate, false) !== false) {
            total += 1
        }
        if (Util.formatData(startDate, false) !== false) {
            total += 1
        }
        setSumFilters(total)
        if (Util.formatData(setSum, false) !== false) {
            setSum(total)
        }
    }

    const handleSubmit = async (status) => {
        if (sumFilter > 0) {
            let data = {
                employee: Util.formatData(employee, ""),
                position: Util.formatData(position, ""),
                team: Util.formatData(team, ""),
                cycle_id: Util.formatData(cycleName, ""),
                form_type: Util.formatData(formType, "evaluate"),
                cycle_type: Util.formatData(cycleType, ""),
                form_template: Util.formatData(templateName, ""),
                form_status: Util.formatData(workflowStatus, ""),
                date_from: Util.formatData(startDate, ""),
                date_to: Util.formatData(endDate, ""),
                status: type === "active" ? "active" : "delete"
            }
            manageForm.getListForm(data).then((rs) => {
                let list = Util.formatData(rs?.data?.forms, [])
                dataSerachs(list)
                setMainItems(list)
                if (Util.formatData(dataFilter?.form_type, []).length > 0) {
                    let filterData = dataFilter?.form_type.filter((rs) => rs?.type?.code === formType)
                    if (Util.formatData(filterData, []).length > 0) {
                        setWorkflowStatusValueOld(filterData[0]?.routes)
                    }
                }
                if (Util.formatData(rs?.data?.form_status, []).length > 0) {
                    setDataWorkflowStatus(rs?.data?.form_status)
                }
                setOldData(data)
                setSelected([]);
            }).catch((err) => {

            })
        }
    }
    const loadData = async () => {
        if (Object.keys(oldData).length > 0) {
            manageForm.getListForm(oldData).then((rs) => {
                let list = Util.formatData(rs?.data?.forms, [])
                dataSerachs(list)
                setMainItems(list)
                if (Util.formatData(dataFilter?.form_type, []).length > 0) {
                    let filterData = dataFilter?.form_type.filter((rs) => rs?.type?.code === formType)
                    if (Util.formatData(filterData, []).length > 0) {
                        setWorkflowStatusValue(filterData[0]?.routes)
                        setListFormStatus(filterData[0]?.routes)
                    }
                }
                setSelected([]);
            }).catch((err) => {

            })
        }
    }
    const loadDataDel = async () => {
        if (Object.keys(oldData).length > 0) {
            manageForm.getListForm(oldData).then((rs) => {
                let list = Util.formatData(rs?.data?.forms, [])
                dataSerachs(list)
                setMainItems(list)
                if (Util.formatData(dataFilter?.form_type, []).length > 0) {
                    let filterData = dataFilter?.form_type.filter((rs) => rs?.type?.code === formType)
                    if (Util.formatData(filterData, []).length > 0) {
                        setWorkflowStatusValue(filterData[0]?.routes)
                        setListFormStatus(filterData[0]?.routes)
                    }
                }
                setSelected([]);
                setIsDeleteForm(false)
            }).catch((err) => {

            })
        }
        openSuccessDeleteDialog(false)
    }
    const handleCancel = () => {
        setEmployee("")
        setPosition("")
        setTeam("")
        setTemplateName("")
        setCycle("")
        setCycleType("")
        setCycleName("")
        setIsProbation(false)
        setValueCycleName("")
        setValueTemplateName("")
        setValueWorkflowStatus("")
        setFormType("")
        setWorkflowStatus("")
        setWorkflowStatusName("")
        setStartDate(null)
        setEndDate(null)
        // setOpenAdvanceFilters(false)
    }

    const handleSearch = (event) => {
        setSearchValue(event.target.value);
    };

    const dataSerachs = async (data, type) => {
        let result = []
        let dataSerach = JSON.parse(JSON.stringify(data))
        if (search !== "" && dataSerach !== undefined && dataSerach.length > 0) {
            let resultData = dataSerach.filter(rs => {
                return Object.keys(rs).some(key => {
                    if (key === 'evaluator' || key === 'form' || key === 'cycle') {
                        let ChangePosition = false;
                        if (rs[key].name !== undefined && rs[key].name.toString().toLowerCase().indexOf(search.toString().toLowerCase()) !== -1) {
                            ChangePosition = true;
                        }
                        if (rs[key].position !== undefined && rs[key].position.toString().toLowerCase().indexOf(search.toString().toLowerCase()) !== -1) {
                            ChangePosition = true;
                        }
                        return ChangePosition;
                    }
                    if (key === 'workflow_status') {
                        if (rs[key].label !== undefined && rs[key].label.toString().toLowerCase().indexOf(search.toString().toLowerCase()) !== -1) {
                            return true;
                        }
                    }
                    if (key === 'employee') {
                        let ChangePosition = false;
                        if (rs[key].name !== undefined && rs[key].name.toString().toLowerCase().indexOf(search.toString().toLowerCase()) !== -1) {
                            ChangePosition = true;
                        }
                        if (rs[key].code !== undefined && rs[key].code.toString().toLowerCase().indexOf(search.toString().toLowerCase()) !== -1) {
                            ChangePosition = true;
                        }
                        if (rs[key].position !== undefined && rs[key].position.toString().toLowerCase().indexOf(search.toString().toLowerCase()) !== -1) {
                            ChangePosition = true;
                        }
                        return ChangePosition;
                    }
                });
            });
            result = resultData
        } else {
            result = dataSerach;
        }
        if (type === "status") {
            if (submit === true) {
                handleSubmit()
            } else {
                setSunmit(false)
                await setItems(result);
            }
        } else {
            setSunmit(false)
            await setItems(result);
        }
    };
    const currentData = useMemo(() => {
        const firstPageIndex = (currentPage - 1) * perPage;
        const lastPageIndex = firstPageIndex + perPage;
        return items
            .slice(firstPageIndex, lastPageIndex);
    }, [items, currentPage, perPage]);
    const handleTotalPage = () => {
        const List = items
        const totalPage =
            Math.ceil(List.length / perPage) === 0
                ? 1
                : Math.ceil(List.length / perPage);
        setTotalPage(totalPage);
    };
    useEffect(() => {
        handleTotalPage();
    }, [items, perPage]);
    useEffect(() => {
        dataSerachs(mainItems)
    }, [search]);
    useEffect(() => {
        if (isCollapse && scroll === false) {
            setIsCollapse(false)
        }
    }, [scroll]);

    useEffect(() => {
        checkFilterData()
    }, [employee, position, team, cycleName, formType, cycleType, templateName, workflowStatus, endDate, startDate]);

    useEffect(() => {
        if (isCollapse) {
            emitCollapse()
        }
    }, [isCollapse]);

    useEffect(() => {
        if (Util.formatData(dataFilter?.form_type, []).length > 0) {
            let filterData = dataFilter?.form_type.filter((rs) => rs?.type?.code === formType)
            if (Util.formatData(filterData, []).length > 0) {
                setWorkflowStatusValue(filterData[0]?.routes)
                setListFormStatus(filterData[0]?.routes)
            }
        }
        setEmployee("")
        setPosition("")
        setTeam("")
        setTemplateName("")
        setWorkflowStatus("")
        setWorkflowStatusName("")
        setStartDate(null)
        setEndDate(null)
    }, [formType]);
    useEffect(() => {
        if (Util.formatData(dataFilter?.templates, []).length > 0) {
            let dataTemplates = []
            if (valueCycleName === "all") {
                dataTemplates = dataFilter?.templates.filter((item) => item.form_type === formType)
            } else {
                dataTemplates = dataFilter?.templates.filter((item) => item.cycle === cycleName && item.form_type === formType)
            }
            setDataFilterTemplates(dataTemplates)
        }
    }, [cycleName, formType]);
    useEffect(() => {
        let update = checkResired
        if (Object.keys(checkResired)[0] !== undefined) {
            if (update[Object.keys(checkResired)[0]] === false) {
                currentData.sort(function (b, a) {
                    if (a[Object.keys(checkResired)[0]] > b[Object.keys(checkResired)[0]]) {
                        return -1;
                    }
                    if (b[Object.keys(checkResired)[0]] > a[Object.keys(checkResired)[0]]) {
                        return 1;
                    }
                    return 0;
                });
                setreSet(!reSet)
            } else if (update[Object.keys(checkResired)[0]] === true) {
                currentData.sort(function (a, b) {
                    if (a[Object.keys(checkResired)[0]] > b[Object.keys(checkResired)[0]]) {
                        return -1;
                    }
                    if (b[Object.keys(checkResired)[0]] > a[Object.keys(checkResired)[0]]) {
                        return 1;
                    }
                    return 0;
                });
                setreSet(!reSet)
            }
        }
    }, [currentData]);

    useEffect(() => {
        dataSerachs(mainItems)
    }, [mainItems]);
    useEffect(() => {
        let maybeHandler = (event) => {
            if (event.target.closest("#boxCollapse") === null) {
                setIsCollapse(false)
            }
        };

        document.addEventListener("click", maybeHandler);

        return () => {
            document.removeEventListener("click", maybeHandler);
        };
    }, []);

    document.addEventListener(
        'keydown',
        function (event) {
            if (isCollapse) {
                setIsCollapse(false);
            }
        },
        true
    );
    const handlePerPageChange = (event) => {
        setPerPage(event.target.value);
    };
    const handleSetCurrentPage = (value) => {
        const getSelectedPage = value.filter(item => item.type === "page" && item.selected)
        setCurrentPage(getSelectedPage.length > 0 ? getSelectedPage[0].page : 1)
    };
    let sortData = (key, check1) => {
        let update = checkResired
        if (check1 === false && update[key] !== check1) {
            currentData.sort(function (b, a) {
                if (key === "employee" || key === "template") {
                    if (a[key].name > b[key].name) {
                        return -1;
                    }
                    if (b[key].name > a[key].name) {
                        return 1;
                    }
                } else {
                    if (a[key] > b[key]) {
                        return -1;
                    }
                    if (b[key] > a[key]) {
                        return 1;
                    }
                }

                return 0;
            });
            update = { [key]: false }
            setCheckRsquired(update)
            setreSet(!reSet)
        } else if (check1 === true && update[key] !== check1) {
            currentData.sort(function (a, b) {
                if (key === "employee" || key === "template") {
                    if (a[key].name > b[key].name) {
                        return -1;
                    }
                    if (b[key].name > a[key].name) {
                        return 1;
                    }
                } else {
                    if (a[key] > b[key]) {
                        return -1;
                    }
                    if (b[key] > a[key]) {
                        return 1;
                    }
                }
                return 0;
            });
            update = { [key]: true }
            setCheckRsquired(update)
            setreSet(!reSet)
        }
    }
    const onOpenAdvanceFilters = () => {
        setOpenAdvanceFilters(!openAdvanceFilters)
    }
    const onChangeEmployee = (val) => {
        setEmployee(val)
    }
    const onChangePosition = (val) => {
        setPosition(val)
    }
    const onChangeTeam = (val) => {
        setTeam(val)
    }
    const onChangeTemplateName = (val, type) => {
        let id = val ? val.id : null
        setTemplateName(id)
        if (type === "all") {
            setValueTemplateName("all")
        } else {
            setValueTemplateName(id)
        }
        console.log('Template', val)

        if (val && val.routes.length > 0) {
            setListFormStatus(val.routes)
        } else {
            setListFormStatus(workflowStatusValue)
        }
    }
    const onChangeCycle = (val) => {
        setCycle(val)
    }
    const onChangeCycleType = (val) => {
        setCycleType(val)
        setEmployee("")
        setPosition("")
        setTeam("")
        setTemplateName("")
        setCycle("")
        setCycleName("")
        setIsProbation(false)
        setValueCycleName("")
        setFormType("")
        setValueTemplateName("")
        setWorkflowStatus("")
        setValueWorkflowStatus("")
        setWorkflowStatusName("")
        setStartDate(null)
        setEndDate(null)
        if (val === "360") {
            setFormType("evaluate")
        } else {
            setFormType("")
        }
    }
    const onChangeCycleName = (val, type) => {
        setCycleName(val ? val.id : null)
        if (type === "all") {
            setValueCycleName("all")
        } else {
            setValueCycleName(val ? val.id : null)
        }

        setIsProbation((val && val.is_probation))
    }
    const onChangeFormType = (val) => {
        setFormType(val)
    }
    const onChangeWorkflowStatus = (val, name, type) => {
        setWorkflowStatus(val)
        setWorkflowStatusName(name)
        if (type === "all") {
            setValueWorkflowStatus("all")
        } else {
            setValueWorkflowStatus(val)
        }
    }
    const onChangeStartDate = (val) => {
        setStartDate(Util.formatDate(val))
    }
    const onChangeEndDate = (val) => {
        setEndDate(Util.formatDate(val))
    }
    const displayCollapse = () => {
        setIsCollapse(!isCollapse)
    }

    const handleDeleteForm = () => {
        setSelected([])
        setIsDeleteForm(!isDeleteForm)
    }
    const handleConfirmDeleteDialog = (val, serial) => {

        openConfirmDeleteDialog(val);
    };
    const handleConfirmRestoreDialog = (val, serial) => {

        openConfirmRestoreDialog(val);
    };
    const handleConfirmDeleteList = () => {
        let dataDel = {
            form_type: Util.formatData(formType, "evaluate"),
            forms: selected
        }
        manageForm.delete(dataDel).then(
            (response) => {
                openConfirmDeleteDialog(false)
                openSuccessDeleteDialog(true)
            },
        ).catch(() => {
            // openConfirmDeleteDialog(false)
            // handleOpenFailedMessageDialog()
        })

    };

    const handleConfirmRestoreList = () => {
        let dataRestore = {
            form_type: Util.formatData(formType, "evaluate"),
            forms: selected
        }
        manageForm.restore(dataRestore).then(
            (response) => {
                loadData()
                openConfirmRestoreDialog(false)
                openSuccessRestoreDialog(true)
            },
        ).catch(() => {
            // openConfirmDeleteDialog(false)
            // handleOpenFailedMessageDialog()
        })

    };

    const handleDeleteClick = () => {
        handleConfirmDeleteDialog(true)
    }

    const handleReStoreClick = () => {
        handleConfirmRestoreDialog(true)
    }

    const [selected, setSelected] = React.useState([]);
    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelecteds = mainItems.map((n) => n.id);
            setSelected(newSelecteds);
            return;
        }
        setSelected([]);
    };

    const handleClick = (event, serial) => {
        const selectedIndex = selected.indexOf(serial);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, serial);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }

        setSelected(newSelected);
    };
    const isSelected = (serial) => selected.indexOf(serial) !== -1;
    const [openReopen, setOpenReopen] = React.useState(false);
    const onOpenReopen = () => {
        setOpenReopen(true)
    }
    const onCloseReopen = (load) => {
        setOpenReopen(false)
        if (load === "load") {
            loadData()
        }
    }
    const [openRoute, setOpenRoute] = React.useState(false);
    const onOpenRoute = () => {
        setOpenRoute(true)
    }
    const onCloseRoute = () => {
        setOpenRoute(false)
    }
    // i18n.language === "th-TH" ?
    let showTemplateName = (data) => {
        let name = ""
        if (Util.formatData(data?.code, "") !== "") {
            name += data.code + " - "
        }
        if (i18n.language === "th-TH") {
            if (Util.formatData(data?.name_th, "") !== "") {
                name += data.name_th
            } else if (Util.formatData(data?.name_en, "") !== "") {
                name += data.name_en
            }
        } else {
            if (Util.formatData(data?.name_en, "") !== "") {
                name += data.name_en
            } else if (Util.formatData(data?.name_th, "") !== "") {
                name += data.name_th
            }
        }
        return name
    }
    const checkButtonFilter = () => {
        if (Util.formatData(cycleType, false) !== false) {
            if (cycleType === "360") {
                if (Util.formatData(valueCycleName, false) !== false && Util.formatData(formType, false) !== false && Util.formatData(valueTemplateName, false) !== false && Util.formatData(valueWorkflowStatus, false) !== false) {
                    console.log("false", 1);
                    return false
                } else {
                    console.log("true", 1);
                    return true
                }
            } else {
                if (Util.formatData(valueCycleName, false) !== false && Util.formatData(formType, false) !== false && Util.formatData(valueTemplateName, false) !== false && Util.formatData(valueWorkflowStatus, false) !== false) {
                    console.log("false", 2);
                    return false
                } else {
                    console.log("true", 2);
                    return true
                }
            }
        } else {
            console.log("true", 3);
            return true
        }
    }
    useEffect(() => {
        checkButtonFilter()
    }, [cycleName, formType, cycleType, templateName, workflowStatus]);
    return (
        <Box sx={{ width: "100%", display: open === true ? "" : "none" }}>
            <Collapse in={openAdvance === true}>
                <Box mt="30px" sx={{ "max-height": "max-content", background: "#FFFFFF", "box-shadow": "0px 2px 10px rgba(0, 0, 0, 0.1)", "border-radius": "10px", padding: "26px 40px 40px 37px" }}>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                        <Typography variant="subtitle1" color="#404349" fontWeight="500" fontSize={24} lineHeight="35px" display="flex">{t('admin.inputForm.advanceFilters')}</Typography>
                        {sumFilter > 0 ?
                            <Box ml="20px" px="12px" sx={{ background: "#5DA196", "border-radius": "5px", height: "35px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                <Typography variant="subtitle1" fontWeight="500" color="#FFFFFF" fontSize={20} lineHeight="22px" display="flex">{sumFilter}</Typography>
                            </Box>
                            :
                            null
                        }
                    </Box>
                    <Typography pt="10px" pb="3px" variant="subtitle1" color="#AAAAAA" fontWeight="400" fontSize={16} lineHeight="17.6px" display="flex">{"Please select the cycle name, template name, and form status accordingly."}</Typography>
                    <Box pl="3px" sx={{ margin: "0 -12.5px", display: "flex", "flex-flow": "row wrap" }}>
                        <Box pt="12px" sx={{ width: "calc(33.33% - 25px)", ".MuiFormControl-root": { "margin-top": "7px" }, ".Mui-disabled": { "& fieldset": { borderColor: "#CED4DA" }, background: "#F3F3F3", "-webkit-text-fill-color": "#AAAAAA !important" }, margin: "0 12.5px" }}>
                            <Typography mb="7px" variant="subtitle1" color="#404349" fontWeight="500" fontSize={18} lineHeight="26.91px" display="flex">Cycle Type <span style={{ color: "#CC6058" }}>*</span></Typography>
                            <Select
                                variant="outlined"
                                defaultValue=""
                                displayEmpty
                                size="small"
                                fullWidth
                                className="white-bg"
                                value={cycleType}
                                classes={{ root: classes.select }}
                                MenuProps={{ autoFocus: false }}
                                inputProps={{
                                    sx: {
                                        "&::placeholder": {
                                            color: "#AAAAAA",
                                            fontWeight: "300",
                                            opacity: "1"
                                        }
                                    }
                                }}
                            >
                                <MenuItem disabled value="" sx={{ display: "none" }}>
                                    <Typography variant="sub_label" style={{ fontSize: "16px", fontWeight: "300", lineHeight: "23.92px", color: "#AAAAAA" }}>{t('label.selectCycleType')}</Typography>
                                </MenuItem>
                                {Util.formatData(dataFilterCycleType, []).length > 0 ?
                                    dataFilterCycleType.map((item, idx) => {
                                        return (
                                            <MenuItem value={item} key={idx} onClick={e => onChangeCycleType(item)}>
                                                <span style={{ color: "#404349", fontSize: "16px", fontWeight: "400", lineHeight: "23.92px" }}>{item === "360" ? "360 Evaluation" : "Annual Evaluation"}</span>
                                            </MenuItem>
                                        )
                                    })
                                    :
                                    Util.formatData(cycleType, false) === false ? null
                                        :
                                        <MenuItem value="">
                                            <Typography variant="sub_label" style={{ fontSize: "16px", fontWeight: "300", lineHeight: "23.92px", color: "#AAAAAA" }}>---{t('label.noData')}---</Typography>
                                        </MenuItem>
                                }
                            </Select>
                        </Box>
                        <Box pt="12px" sx={{ width: "calc(33.33% - 25px)", ".MuiFormControl-root": { "margin-top": "7px" }, ".Mui-disabled": { "& fieldset": { borderColor: "#CED4DA" }, ".MuiSelect-select": { background: "#F3F3F3", }, background: "#F3F3F3", "-webkit-text-fill-color": "#AAAAAA !important" }, margin: "0 12.5px" }}>
                            <Typography mb="7px" variant="subtitle1" color="#404349" fontWeight="500" fontSize={18} lineHeight="26.91px" display="flex">Cycle Name <span style={{ color: "#CC6058" }}>*</span></Typography>
                            <Select
                                variant="outlined"
                                defaultValue=""
                                displayEmpty
                                size="small"
                                fullWidth
                                className="white-bg"
                                value={cycleName}
                                classes={{ root: classes.select }}
                                disabled={Util.formatData(cycleType, false) === false}
                                MenuProps={{ autoFocus: false }}
                                inputProps={{
                                    sx: {
                                        "&::placeholder": {
                                            color: "#AAAAAA",
                                            fontWeight: "300",
                                            opacity: "1"
                                        }
                                    }
                                }}
                            >
                                <MenuItem disabled value="" sx={{ display: "none" }}>
                                    <Typography variant="sub_label" style={{ fontSize: "16px", fontWeight: "300", lineHeight: "23.92px", color: "#AAAAAA" }}>{t('label.selectCycleName')}</Typography>
                                </MenuItem>
                                {Util.formatData(dataFilter?.cycles, []).length > 0 ?
                                    dataFilter?.cycles.map((item, idx) => {
                                        return (
                                            <MenuItem value={item.id} key={idx} onClick={e => onChangeCycleName(item, "")}>
                                                <span style={{ color: "#404349", fontSize: "16px", fontWeight: "400", lineHeight: "23.92px" }}>{item?.name}</span>
                                            </MenuItem>
                                        )
                                    })
                                    :
                                    null
                                }
                            </Select>
                        </Box>
                        <Box pt="12px" sx={{ width: "calc(33.33% - 25px)", ".MuiFormControl-root": { "margin-top": "7px" }, ".Mui-disabled": { "& fieldset": { borderColor: "#CED4DA" }, ".MuiSelect-select": { background: "#F3F3F3", }, background: "#F3F3F3", "-webkit-text-fill-color": "#AAAAAA !important" }, margin: "0 12.5px" }}>
                            <Typography mb="7px" variant="subtitle1" color="#404349" fontWeight="500" fontSize={18} lineHeight="26.91px" display="flex">{t('label.formType')} <span style={{ color: "#CC6058" }}>*</span></Typography>
                            <Select
                                variant="outlined"
                                defaultValue=""
                                displayEmpty
                                size="small"
                                fullWidth
                                className="white-bg"
                                value={formType}
                                classes={{ root: classes.select }}
                                disabled={cycleType === '360' ? true : Util.formatData(valueCycleName, false) === false ? true : false}
                                MenuProps={{ autoFocus: false }}
                                inputProps={{
                                    sx: {
                                        "&::placeholder": {
                                            color: "#AAAAAA",
                                            fontWeight: "300",
                                            opacity: "1"
                                        }
                                    }
                                }}
                            >
                                <MenuItem disabled value="" sx={{ display: "none" }}>
                                    <Typography variant="sub_label" style={{ fontSize: "16px", fontWeight: "300", lineHeight: "23.92px", color: "#AAAAAA" }}>{t('label.selectFormType')}</Typography>
                                </MenuItem>
                                {Util.formatData(dataFilter?.form_type, []).length > 0 ?
                                    dataFilter?.form_type.map((item, idx) => {
                                        return (
                                            <MenuItem value={Util.formatData(item?.type?.code, "evaluate")} key={idx} onClick={e => onChangeFormType(Util.formatData(item?.type?.code, "evaluate"))}>
                                                <span style={{ color: "#404349", fontSize: "16px", fontWeight: "400", lineHeight: "23.92px" }}>{Util.formatData(item?.type?.label, "Evaluate")}</span>
                                            </MenuItem>
                                        )
                                    })
                                    :
                                    Util.formatData(formType, false) === false ? null
                                        :
                                        <MenuItem value="">
                                            <Typography variant="sub_label" style={{ fontSize: "16px", fontWeight: "300", lineHeight: "23.92px", color: "#AAAAAA" }}>---{t('label.noData')}---</Typography>
                                        </MenuItem>
                                }
                            </Select>
                        </Box>
                        <Box pt="12px" sx={{ width: "calc(33.33% - 25px)", ".MuiFormControl-root": { "margin-top": "7px" }, ".Mui-disabled": { "& fieldset": { borderColor: "#CED4DA" }, ".MuiSelect-select": { background: "#F3F3F3", }, background: "#F3F3F3", "-webkit-text-fill-color": "#AAAAAA !important" }, margin: "0 12.5px" }}>
                            <Typography mb="7px" variant="subtitle1" color="#404349" fontWeight="500" fontSize={18} lineHeight="26.91px" display="flex">{t('label.templateName')} <span style={{ color: "#CC6058" }}>*</span></Typography>
                            <Select
                                variant="outlined"
                                defaultValue=""
                                displayEmpty
                                size="small"
                                fullWidth
                                className="white-bg"
                                value={templateName}
                                classes={{ root: classes.select }}
                                disabled={Util.formatData(valueCycleName, false) !== false && Util.formatData(formType, false) !== false ? false : true}
                                MenuProps={{ autoFocus: false }}
                                inputProps={{
                                    sx: {
                                        "&::placeholder": {
                                            color: "#AAAAAA",
                                            fontWeight: "300",
                                            opacity: "1"
                                        }
                                    }
                                }}
                            >
                                <MenuItem disabled value="" sx={{ display: "none" }}>
                                    <Typography variant="sub_label" style={{ fontSize: "16px", fontWeight: "300", lineHeight: "23.92px", color: "#AAAAAA" }}>{t('label.selectTemplateName')}</Typography>
                                </MenuItem>
                                <MenuItem value={null} key={"all"} onClick={e => onChangeTemplateName(null, "all")}>
                                    <span style={{ color: "#404349", fontSize: "16px", fontWeight: "400", lineHeight: "23.92px" }}>Select all</span>
                                </MenuItem>
                                {Util.formatData(dataFilterTemplates, []).length > 0 ?
                                    dataFilterTemplates.map((item, idx) => {
                                        return (
                                            <MenuItem value={item.id} key={idx} onClick={e => onChangeTemplateName(item, "")}>
                                                <span style={{ color: "#404349", fontSize: "16px", fontWeight: "400", lineHeight: "23.92px" }}>{showTemplateName(item)}</span>
                                            </MenuItem>
                                        )
                                    })
                                    :
                                    null
                                }
                            </Select>
                        </Box>
                        <Box pt="12px" sx={{ width: "calc(33.33% - 25px)", ".MuiButtonBase-root": { "justify-content": "flex-end", position: "absolute", width: "100%", height: "100%", left: "0", "border-radius": "unset" }, ".Mui-disabled": { "& fieldset": { borderColor: "#CED4DA" }, background: "#F3F3F3", "-webkit-text-fill-color": "#AAAAAA !important" }, ".MuiFormControl-root": { "margin-top": "7px" }, margin: "0 12.5px", '& div > div > input': { height: '7px', }, position: "relative" }} >
                            <Typography fontSize={16} lineHeight="23.96px" color="#404349" fontWeight="300px" sx={{ position: "absolute", bottom: "8px", right: "-16px", }}>
                                -
                            </Typography>
                            <Typography variant="subtitle1" color="#404349" fontWeight="500" fontSize={18} lineHeight="26.91px" display="flex">Period Date From</Typography>
                            <LocalizationProvider dateAdapter={AdapterDateFns} >
                                <DatePicker
                                    slots={{
                                        OpenPickerIcon: Calendar
                                    }}
                                    format="dd/MM/yyyy"
                                    value={startDate}
                                    onChange={(newValue) => {
                                        onChangeStartDate(newValue)
                                    }}
                                    // minDate={item.validator.min_date !== undefined && item.validator.min_date !== null && item.validator.min_date !== "" ? formik.values[item.validator.min_date] !== undefined && formik.values[item.validator.min_date] !== null && formik.values[item.validator.min_date] !== "" ? new Date(formik.values[item.validator.min_date]) : null : null}
                                    // maxDate={item.validator.max_date !== undefined && item.validator.max_date !== null && item.validator.max_date !== "" ? formik.values[item.validator.max_date] !== undefined && formik.values[item.validator.max_date] !== null && formik.values[item.validator.max_date] !== "" ? new Date(formik.values[item.validator.max_date]) : null : null}
                                    disabled={Util.formatData(cycleType, false) === false}
                                    inputProps={{ placeholder: t('admin.inputForm.placeholder.selectDate'), readOnly: true, sx: { "&::placeholder": { color: "#AAAAAA", fontWeight: "300", opacity: "1" } } }}
                                    renderInput={(params) => <TextField {...params}
                                        sx={{ ".MuiOutlinedInput-root": { color: "#404349", } }}
                                        fullWidth
                                    />
                                    }
                                />
                            </LocalizationProvider>
                        </Box>
                        <Box pt="12px" sx={{ width: "calc(33.33% - 25px)", ".MuiButtonBase-root": { "justify-content": "flex-end", position: "absolute", width: "100%", height: "100%", left: "0", "border-radius": "unset" }, ".Mui-disabled": { "& fieldset": { borderColor: "#CED4DA" }, background: "#F3F3F3", "-webkit-text-fill-color": "#AAAAAA !important" }, ".MuiFormControl-root": { "margin-top": "7px" }, margin: "0 12.5px", '& div > div > input': { height: '7px', } }}>
                            <Typography variant="subtitle1" color="#404349" fontWeight="500" fontSize={18} lineHeight="26.91px" display="flex">Period Date To</Typography>
                            <LocalizationProvider dateAdapter={AdapterDateFns} >
                                <DatePicker
                                    slots={{
                                        OpenPickerIcon: Calendar
                                    }}
                                    format="dd/MM/yyyy"
                                    value={endDate}
                                    onChange={(newValue) => {
                                        onChangeEndDate(newValue)
                                    }}
                                    // minDate={item.validator.min_date !== undefined && item.validator.min_date !== null && item.validator.min_date !== "" ? formik.values[item.validator.min_date] !== undefined && formik.values[item.validator.min_date] !== null && formik.values[item.validator.min_date] !== "" ? new Date(formik.values[item.validator.min_date]) : null : null}
                                    // maxDate={item.validator.max_date !== undefined && item.validator.max_date !== null && item.validator.max_date !== "" ? formik.values[item.validator.max_date] !== undefined && formik.values[item.validator.max_date] !== null && formik.values[item.validator.max_date] !== "" ? new Date(formik.values[item.validator.max_date]) : null : null}
                                    disabled={Util.formatData(cycleType, false) === false}
                                    inputProps={{ placeholder: t('admin.inputForm.placeholder.selectDate'), readOnly: true, sx: { "&::placeholder": { color: "#AAAAAA", fontWeight: "300", opacity: "1" } } }}
                                    renderInput={(params) => <TextField {...params}
                                        sx={{ ".MuiOutlinedInput-root": { color: "#404349", } }}
                                        fullWidth
                                    />
                                    }
                                />
                            </LocalizationProvider>
                        </Box>
                        <Box pt="12px" sx={{ width: "calc(33.33% - 25px)", ".MuiFormControl-root": { "margin-top": "7px" }, ".Mui-disabled": { "& fieldset": { borderColor: "#CED4DA" }, ".MuiSelect-select": { background: "#F3F3F3", }, background: "#F3F3F3", "-webkit-text-fill-color": "#AAAAAA !important" }, margin: "0 12.5px" }}>
                            <Typography mb="7px" variant="subtitle1" color="#404349" fontWeight="500" fontSize={18} lineHeight="26.91px" display="flex">{t('label.titleForm.formStatus')} <span style={{ color: "#CC6058" }}>*</span></Typography>
                            <Select
                                variant="outlined"
                                defaultValue=""
                                displayEmpty
                                size="small"
                                fullWidth
                                className="white-bg"
                                value={workflowStatus}
                                classes={{ root: classes.select }}
                                disabled={Util.formatData(formType, false) === false}
                                MenuProps={{ autoFocus: false }}
                                inputProps={{
                                    sx: {
                                        "&::placeholder": {
                                            color: "#AAAAAA",
                                            fontWeight: "300",
                                            opacity: "1"
                                        }
                                    }
                                }}
                            >
                                <MenuItem disabled value="" sx={{ display: "none" }}>
                                    <Typography variant="sub_label" style={{ fontSize: "16px", fontWeight: "300", lineHeight: "23.92px", color: "#AAAAAA" }}>{t('admin.inputForm.placeholder.selectFormStatus')}</Typography>
                                </MenuItem>
                                <MenuItem value={null} key={"all"} onClick={e => onChangeWorkflowStatus(null, "All", "all")}>
                                    <span style={{ color: "#404349", fontSize: "16px", fontWeight: "400", lineHeight: "23.92px" }}>Select all</span>
                                </MenuItem>
                                {Util.formatData(listFormStatus, []).length > 0 ?
                                    listFormStatus.map((item, idx) => {
                                        return (
                                            <MenuItem value={item.code} key={idx} onClick={e => onChangeWorkflowStatus(item.code, item?.label, "")}>
                                                <span style={{ color: "#404349", fontSize: "16px", fontWeight: "400", lineHeight: "23.92px" }}>{item?.label}</span>
                                            </MenuItem>
                                        )
                                    })
                                    :
                                    null
                                }
                            </Select>
                        </Box>
                        <Box pt="12px" sx={{ width: "calc(33.33% - 25px)", ".MuiFormControl-root": { "margin-top": "7px" }, ".Mui-disabled": { "& fieldset": { borderColor: "#CED4DA" }, background: "#F3F3F3", "-webkit-text-fill-color": "#AAAAAA !important" }, margin: "0 12.5px" }}>
                            <Typography variant="subtitle1" color="#404349" fontWeight="500" fontSize={18} lineHeight="26.91px" display="flex">{t('label.employee')}</Typography>
                            <TextField
                                fullWidth
                                margin="normal"
                                name="description"
                                onChange={(newValue) => {
                                    onChangeEmployee(newValue.target.value);
                                }}
                                type="text"
                                value={employee}
                                variant="outlined"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                disabled={Util.formatData(cycleType, false) === false}
                                inputProps={{
                                    sx: {
                                        "&::placeholder": {
                                            color: "#AAAAAA",
                                            fontWeight: "300",
                                            opacity: "1"
                                        }
                                    }
                                }}
                                sx={{ ".MuiOutlinedInput-root": { color: "#404349", } }}
                                placeholder={t('admin.inputForm.placeholder.searchCodeOrName')}
                                classes={{ root: classes.input }}
                            />
                        </Box>
                        <Box pt="12px" sx={{ width: "calc(33.33% - 25px)", ".MuiFormControl-root": { "margin-top": "7px" }, ".Mui-disabled": { "& fieldset": { borderColor: "#CED4DA" }, background: "#F3F3F3", "-webkit-text-fill-color": "#AAAAAA !important" }, margin: "0 12.5px" }}>
                            <Typography variant="subtitle1" color="#404349" fontWeight="500" fontSize={18} lineHeight="26.91px" display="flex">{t('label.positions')}</Typography>
                            <TextField
                                fullWidth
                                margin="normal"
                                name="description"
                                onChange={(newValue) => {
                                    onChangePosition(newValue.target.value);
                                }}
                                type="text"
                                value={position}
                                variant="outlined"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                disabled={Util.formatData(cycleType, false) === false}
                                inputProps={{
                                    sx: {
                                        "&::placeholder": {
                                            color: "#AAAAAA",
                                            fontWeight: "300",
                                            opacity: "1"
                                        }
                                    }
                                }}
                                sx={{ ".MuiOutlinedInput-root": { color: "#404349", } }}
                                placeholder={t('admin.inputForm.placeholder.searchCodeOrName')}
                                classes={{ root: classes.input }}
                            />
                        </Box>
                        <Box pt="12px" sx={{ width: "calc(33.33% - 25px)", ".MuiFormControl-root": { "margin-top": "7px" }, ".Mui-disabled": { "& fieldset": { borderColor: "#CED4DA" }, background: "#F3F3F3", "-webkit-text-fill-color": "#AAAAAA !important" }, margin: "0 12.5px" }}>
                            <Typography variant="subtitle1" color="#404349" fontWeight="500" fontSize={18} lineHeight="26.91px" display="flex">{t('label.team')}</Typography>
                            <TextField
                                fullWidth
                                margin="normal"
                                name="description"
                                onChange={(newValue) => {
                                    onChangeTeam(newValue.target.value);
                                }}
                                type="text"
                                value={team}
                                variant="outlined"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                disabled={Util.formatData(cycleType, false) === false}
                                inputProps={{
                                    sx: {
                                        "&::placeholder": {
                                            color: "#AAAAAA",
                                            fontWeight: "300",
                                            opacity: "1"
                                        }
                                    }
                                }}
                                sx={{ ".MuiOutlinedInput-root": { color: "#404349", } }}
                                placeholder={t('admin.inputForm.placeholder.searchCodeOrName')}
                                classes={{ root: classes.input }}
                            />
                        </Box>
                    </Box>
                    <Box sx={{ "justify-content": "flex-end", display: "flex", "padding-top": "22px" }}>
                        <Box sx={{ display: "flex", }}>
                            <Box mr="30px
                            " sx={{ width: "100px" }}>
                                <Button color="black" variant="outlined" fullWidth onClick={handleCancel}>
                                    <Typography sx={{ textTransform: "none" }} fontSize={18} lineHeight="29px" fontWeight="500" color="#404349">{t('admin.inputForm.clear')}</Typography>
                                </Button>
                            </Box>
                            <Button onClick={handleSubmit} disabled={checkButtonFilter()} color="primary" variant="contained" fullWidth>
                                <Typography sx={{ textTransform: "none" }} fontSize={18} lineHeight="29px" fontWeight="500" color="#FFF">{t('label.applyFilter')}</Typography>
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </Collapse>
            <Box pt="30px" pb="30px" sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <TextField
                        id="input-with-icon-textfield"
                        fullWidth
                        placeholder={t('competencyMapping.search')}
                        size="small"
                        sx={{ background: "#fff", width: "400px", "input": { padding: "11px 14px" } }}
                        className="searchTextField-h40"
                        value={search}
                        onChange={handleSearch}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <Search style={{ color: "#C4C4C4" }} />
                                </InputAdornment>
                            ),
                        }}
                    />
                </Box>
                {isDeleteForm === true ?
                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                        {selected.length > 0 ?
                            <Box sx={{ backgroundColor: "#CC60581A", padding: "9px 20px", borderRadius: "5px" }}>
                                <Typography color="#CC6058" fontSize={18} lineHeight="26.91px" fontWeight={400} >Selected Forms: {selected.length}</Typography>
                            </Box> : null
                        }
                        <Button
                            size="small"
                            aria-controls="simple-menu"
                            aria-haspopup="true"
                            onClick={handleDeleteForm}
                            color="black"
                            variant="outlined"
                            sx={{ height: "45px", p: "0 20px", textTransform: "none", "margin-left": "30px" }}
                        >
                            <CancelIcon />
                            <Typography pl="10px" sx={{ textTransform: "none" }} fontSize={18} lineHeight="26.91px" fontWeight="500" color="#393939">
                                {/* {t('label.cancel')} */}
                                Cancel
                            </Typography>
                        </Button>
                        <Button
                            size="small"
                            aria-controls="simple-menu"
                            aria-haspopup="true"
                            onClick={(e) => { handleDeleteClick() }}
                            color="red"
                            variant="contained"
                            disabled={Util.formatData(selected?.length, 0) <= 0}
                            sx={{ height: "45px", p: "0 20px", textTransform: "none", "margin-left": "30px" }}
                        >
                            <DeleteIcon className={classes.plusSvg} />
                            <Typography pl="10px" sx={{ textTransform: "none" }} fontSize={18} lineHeight="26.91px" fontWeight="500" color="#FFFFFF">{t('admin.label.deleteForm')}</Typography>
                        </Button>
                    </Box>
                    :
                    type === "deleted" ?
                        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                            {selected.length > 0 ?
                                <Box sx={{ backgroundColor: "#5DA1961A", padding: "9px 20px", borderRadius: "5px" }}>
                                    <Typography color="#5DA196" fontSize={18} lineHeight="26.91px" fontWeight={400} >Selected Items: {selected.length}</Typography>
                                </Box>
                                : null
                            }
                            <Button
                                size="small"
                                aria-controls="simple-menu"
                                aria-haspopup="true"
                                onClick={(e) => { handleReStoreClick() }}
                                color="primary"
                                variant="contained"
                                disabled={Util.formatData(selected?.length, 0) <= 0}
                                sx={{ height: "45px", p: "0 20px", textTransform: "none", "margin-left": "30px" }}
                            >
                                <RestoreIcon className={classes.plusSvg} />
                                <Typography pl="10px" fontWeight="400" fontSize={18} lineHeight="23.92px" sx={{ width: "calc(100% - 25px)", color: "#FFFFFF", }}>
                                    {t('admin.label.restore')}
                                </Typography>
                            </Button>
                        </Box>
                        :
                        <Box onClick={displayCollapse} id="boxCollapse" ml="30px" px="11px" py="8px" sx={{ position: "relative", border: "1px solid #5DA196", "border-radius": "5px", background: "#5DA196", cursor: "pointer", '&:hover': { background: 'rgb(65, 112, 105)' } }}>
                            <Box sx={{ display: "flex", "align-items": "center" }}>
                                <Typography pr="10px" color="#FFFFFF" fontWeight="500" fontSize={18} lineHeight="26.91px" display="flex">{t('label.titleForm.action')}</Typography>
                                <ChevronDown class={`${classes.fillWhite}`} />
                            </Box>
                            <Box sx={{ position: "absolute", right: "0", top: "59px", "z-index": "2" }} >

                                <Collapse in={isCollapse}>
                                    <Box pt="5px" sx={{ minWidth: "175px", background: "#FFFFFF", "box-shadow": "0px 4px 4px rgba(0, 0, 0, 0.25)", "border-radius": "8px" }}>
                                        <Box>

                                            {(currentData !== undefined && currentData !== null && currentData.length > 0) ?
                                                <Box px="15px" py="10px" display="flex" onClick={onOpenRoute} sx={{ position: "relative", "&:hover": { cursor: "pointer", "&:before": { content: '""', position: "absolute", top: "3px", left: "3px", height: "calc(100% - 6px)", width: "calc(100% - 6px)", background: "rgba(93, 161, 150, 0.2)", "border-radius": "4px", } } }}>
                                                    <Box width="20px" alignItems="center" display="flex">
                                                        <Route />
                                                    </Box>
                                                    <Typography pl="10px" fontWeight="400" fontSize={16} lineHeight="23.92px" sx={{ width: "calc(100% - 25px)", color: "#404349", "white-space": "nowrap", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                                        {t('admin.label.route')}
                                                    </Typography>
                                                </Box>
                                                :
                                                <Box px="15px" py="10px" display="flex" sx={{ position: "relative", cursor: "no-drop", pointerEvents: "none" }}>
                                                    <Box width="20px" alignItems="center" display="flex">
                                                        <Route style={{ opacity: "0.2", cursor: "no-drop", pointerEvents: "none" }} />
                                                    </Box>
                                                    <Typography pl="10px" fontWeight="400" fontSize={16} lineHeight="23.92px" sx={{ width: "calc(100% - 25px)", color: "#404349", "white-space": "nowrap", overflow: "hidden", "text-overflow": "ellipsis", opacity: "0.2", cursor: "no-drop", pointerEvents: "none" }}>
                                                        {t('admin.label.route')}
                                                    </Typography>
                                                </Box>
                                            }

                                        </Box>
                                        <Box>

                                            {(currentData !== undefined && currentData !== null && currentData.length > 0 && cycleType !== "360") ?
                                                <Box px="15px" py="10px" display="flex" onClick={onOpenReopen} sx={{ position: "relative", "&:hover": { cursor: "pointer", "&:before": { content: '""', position: "absolute", top: "3px", left: "3px", height: "calc(100% - 6px)", width: "calc(100% - 6px)", background: "rgba(93, 161, 150, 0.2)", "border-radius": "4px", } } }}>
                                                    <Box width="20px" alignItems="center" display="flex">
                                                        <Reopen />
                                                    </Box>
                                                    <Typography pl="10px" fontWeight="400" fontSize={16} lineHeight="23.92px" sx={{ width: "calc(100% - 25px)", color: "#404349", "white-space": "nowrap", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                                        {t('admin.label.reopen')}
                                                    </Typography>
                                                </Box>
                                                :
                                                <Box px="15px" py="10px" display="flex" sx={{ position: "relative", cursor: "no-drop", pointerEvents: "none" }}>
                                                    <Box width="20px" alignItems="center" display="flex">
                                                        <Reopen style={{ opacity: "0.2", cursor: "no-drop", pointerEvents: "none" }} />
                                                    </Box>
                                                    <Typography pl="10px" fontWeight="400" fontSize={16} lineHeight="23.92px" sx={{ width: "calc(100% - 25px)", color: "#404349", "white-space": "nowrap", overflow: "hidden", "text-overflow": "ellipsis", opacity: "0.2", cursor: "no-drop", pointerEvents: "none" }}>
                                                        {t('admin.label.reopen')}
                                                    </Typography>
                                                </Box>
                                            }
                                        </Box>

                                        {formType !== 'goal' &&
                                            <Box>
                                                <Box px="15px" py="10px" display="flex" onClick={handleDeleteForm} sx={{ position: "relative", "&:hover": { cursor: "pointer", "&:before": { content: '""', position: "absolute", top: "3px", left: "3px", height: "calc(100% - 6px)", width: "calc(100% - 6px)", background: "rgba(93, 161, 150, 0.2)", "border-radius": "4px", } } }}>
                                                    <Box width="20px" alignItems="center" display="flex">
                                                        <DeleteIcon />
                                                    </Box>
                                                    <Typography pl="10px" fontWeight="400" fontSize={16} lineHeight="23.92px" sx={{ width: "calc(100% - 25px)", color: "#404349", "white-space": "nowrap", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                                        {t('admin.label.deleteForm')}
                                                    </Typography>
                                                </Box>
                                            </Box>
                                        }

                                    </Box>
                                </Collapse>

                            </Box>
                        </Box>
                }
            </Box>
            <div className={classes.root}>
                <Paper className={classes.flexPaper} >
                    <Box
                        px="40px"
                    >
                        <Box py="19px" pr="20px" sx={{ display: "flex", "flex-direction": "row" }}  >
                            <Box sx={{ display: "flex", "flex-direction": "row", width: "calc(42.95% - 66.67px)" }} pr="20px">
                                <Box sx={{ width: "65px" }}>
                                    {isDeleteForm === true || type === "deleted" ?
                                        mainItems.length > 0 ?
                                            <Checkbox
                                                sx={{ margin: "0 20px", padding: "0" }}
                                                checked={mainItems.length > 0 && selected.length === mainItems.length}
                                                indeterminate={selected.length > 0 ? selected.length !== mainItems.length : false}
                                                onChange={handleSelectAllClick}
                                            />
                                            : null
                                        : null
                                    }
                                </Box>
                                <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="500" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                    {t('label.titleForm.template')}
                                </Typography>
                                <Typography component="span" style={{ "flex-direction": "column", "justify-content": "center", "display": "flex" }}>
                                    <ChevronExpandUp style={{ cursor: "pointer" }} onClick={e => sortData("template", true)} />
                                    <ChevronExpandDown style={{ cursor: "pointer" }} onClick={e => sortData("template", false)} />
                                </Typography>
                            </Box>
                            <Box sx={{ display: "flex", "flex-direction": "row", width: "calc(33.25% - 66.67px)" }} pr="15px">
                                <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="500" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                    {t('label.titleForm.employeeName')}
                                </Typography>
                                <Typography component="span" style={{ "flex-direction": "column", "justify-content": "center", "display": "flex" }}>
                                    <ChevronExpandUp style={{ cursor: "pointer" }} onClick={e => sortData("employee", true)} />
                                    <ChevronExpandDown style={{ cursor: "pointer" }} onClick={e => sortData("employee", false)} />
                                </Typography>
                            </Box>
                            <Box sx={{ display: "flex", "flex-direction": "row", width: "calc(23.80% - 66.67px)" }} pr="15px">
                                <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="500" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                    {t('label.titleForm.formStatus')}
                                </Typography>
                                <Typography component="span" style={{ "flex-direction": "column", "justify-content": "center", "display": "flex" }}>
                                    <ChevronExpandUp style={{ cursor: "pointer" }} onClick={e => sortData("form_status", true)} />
                                    <ChevronExpandDown style={{ cursor: "pointer" }} onClick={e => sortData("form_status", false)} />
                                </Typography>
                            </Box>
                            <Box sx={{ display: "flex", "flex-direction": "row", width: "100px" }}>
                                <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="500" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                    {/* {t('admin.label.action')} */}
                                    Status
                                </Typography>
                            </Box>
                            <Box sx={{ display: "flex", "flex-direction": "row", width: "100px" }}>
                                <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="500" sx={{ "text-align": "center", "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                    {t('admin.label.action')}
                                </Typography>
                            </Box>
                        </Box>
                        <Divider width="100%" />
                    </Box>
                    {currentData !== undefined && currentData !== null && currentData.length > 0 ? currentData.map((rs, index) => (
                        <Column data={rs} workflowStatus={workflowStatusValueOld} isDeleteForm={isDeleteForm} type={type} selected={selected} handleClick={handleClick} cycleType={cycleType} formType={formType} />
                    ))
                        :
                        <Box sx={{ "padding-top": "300px", "text-align": "center", "padding-bottom": "300px" }}>
                            <Nodata />
                            <Typography color="#A0A0A0" fontWeight="500" fontSize={20} lineHeight="30px" >
                                {t('label.noDataFilter')}
                            </Typography>
                            <Typography color="#A0A0A0" fontWeight="400" fontSize={16} lineHeight="24px" >
                                {t('label.tryChangingFilter')}
                            </Typography>
                        </Box>
                    }
                </Paper>
            </div>
            <Box container mt={3} spacing={2} display="flex" justifyContent="space-between" >
                <Box display="flex" alignItems="center">
                    <Box mr={1}>
                        <Typography variant="s14_fw400">{t('label.showMaxItems')}</Typography>
                    </Box>
                    <Select
                        id="pagination"
                        variant="outlined"
                        defaultValue={10}
                        value={perPage}
                        onChange={handlePerPageChange}
                        displayEmpty
                        size="small"
                        className="white-bg"
                    >
                        <MenuItem value={10}>
                            <Typography style={{ fontWeight: "300" }}>10</Typography>
                        </MenuItem>
                        <MenuItem value={20}>
                            <Typography style={{ fontWeight: "300" }}>20</Typography>
                        </MenuItem>
                        <MenuItem value={30}>
                            <Typography style={{ fontWeight: "300" }}>30</Typography>
                        </MenuItem>
                    </Select>
                </Box>
                <Box item display="flex" pl="16px">
                    <Box item display="flex" alignItems="center" ml="auto">
                        <Typography variant="s14_fw400">
                            {t('label.page')} {currentPage} {t('label.of')} {totalPage}
                        </Typography>
                    </Box>
                    <Box item ml="auto" display="flex" alignItems="center">
                        <CustomPagination
                            setCurrentPage={handleSetCurrentPage}
                            selected={currentPage}
                            count={totalPage}
                        ></CustomPagination>
                    </Box>
                </Box>
            </Box>
            <SimpleDialog
                open={isSuccessRestoreDialogOpen}
                setValue={openSuccessRestoreDialog}
                text={`Form was restored`}
                doDirect={loadData}
            />
            <DialogSubTitle
                open={isSuccessDeleteDialogOpen}
                setValue={openSuccessDeleteDialog}
                text={`Form was deleted successfully.`}
                page={true}
                doDirect={loadDataDel}
                subText={`The deleted form can be restored from deleted tab`}
            />
            <ConfirmDialog open={isConfirmDeleteDialogOpen} doConfirm={handleConfirmDeleteList} setValue={handleConfirmDeleteDialog} title={t('label.confirmationofDeletion')} text={`Are you sure to delete ${Util.formatData(selected?.length, 0)} forms?`} />
            <ConfirmDialog open={isConfirmRestoreDialogOpen} warning={true} doConfirm={handleConfirmRestoreList} setValue={handleConfirmRestoreDialog} title="Confirmation of Restore" text="Are you sure to restore?" />
            <DialogReopen open={openReopen} dataFilter={dataFilter} currentData={items} valueFormType={formType} valueCycleName={cycleName} valueTemplateName={templateName} close={onCloseReopen} />
            <DialogRoute open={openRoute} dataFilter={dataFilter} currentData={items} valueFormType={formType} valueCycleName={cycleName} valueCycleType={cycleType} valueWorkflowStatus={workflowStatusName} dataWorkflowStatus={dataWorkflowStatus} isProbation={isProbation} close={onCloseRoute} />
        </Box >
    );
};
export default ManageForm;
